class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content) return;

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.restartContentAnimation();
    } else {
      this.content.getAnimations().forEach((animation) => animation.cancel());
    }
  }

  restartContentAnimation() {
    this.content.style.animation = 'none';
    this.content.offsetWidth;
    this.content.style.removeProperty('animation');
    this.content.getAnimations().forEach((animation) => {
      animation.currentTime = 0;
      animation.play();
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseTimeout = null;
    this.onPointerEnterHandler = this.onPointerEnter.bind(this);
    this.onPointerLeaveHandler = this.onPointerLeave.bind(this);
    this.onSummaryClickHandler = this.onSummaryClick.bind(this);

    this.addEventListener('pointerenter', this.onPointerEnterHandler);
    this.addEventListener('pointerleave', this.onPointerLeaveHandler);
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClickHandler);
  }

  hoverEnabled() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  onPointerEnter(event) {
    if (event.pointerType === 'touch' || !this.hoverEnabled()) return;
    clearTimeout(this.hoverCloseTimeout);
    this.open();
  }

  onPointerLeave(event) {
    if (event.pointerType === 'touch' || !this.hoverEnabled()) return;
    this.hoverCloseTimeout = setTimeout(() => this.close(), 200);
  }

  onSummaryClick(event) {
    if (event.pointerType === 'touch' || !this.hoverEnabled()) return;
    event.preventDefault();
  }

  open() {
    if (this.mainDetailsToggle.open) return;

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });

    super.open();
  }

  close() {
    clearTimeout(this.hoverCloseTimeout);
    super.close();
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
